import {Component, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {FormControl} from '@ngneat/reactive-forms';
import {startWith, Subscription} from 'rxjs';

import {ValueEdit} from '../../value-edit';

@Component({
  selector: 'ax-email-edit',
  templateUrl: './email-edit.component.html',
  styleUrls: [
    './email-edit.component.scss',
    '../../../property-edit/show-icon.scss',
    '../../placeholder.scss',
  ],
})
export class EmailEditComponent extends ValueEdit implements OnDestroy, OnChanges {
  valueForm: FormControl<string> = new FormControl('');

  private _subscription = new Subscription();
  private _valueChangingByUser = false;

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes.form && this.form) {
      if (this.form.value) {
        this.valueForm.setValue(<string>this.form.value);
      }
      this._subscription.add(
        this.form.valueChanges.subscribe(() => {
          if (!this._valueChangingByUser && this.form.value) {
            this.valueForm.setValue(<string>this.form.value);
          }
          if (this.form.errors) {
            this.valueForm.setErrors(this.form.errors);
          }

          if (this.form.touched) {
            this.valueForm.markAsTouched();
          }
          if (this.form.dirty) {
            this.valueForm.markAsDirty();
          }
        })
      );
      this._subscription.add(
        this.valueForm.valueChanges.pipe(startWith(this.form.value)).subscribe((value) => {
          const lowerCaseEmail = value ? (<string>value || '').toLowerCase() : undefined;
          if (lowerCaseEmail !== this.form.value) {
            this._valueChangingByUser = true;
            this.form.setValue(lowerCaseEmail);
          }
          if (this.valueForm.touched) {
            this.form.markAsTouched();
          }

          if (this.valueForm.touched) {
            this.form.markAsTouched();
          }
          if (this.valueForm.dirty) {
            this.form.markAsDirty();
          }
        })
      );
    }
  }

  override ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
